import { GREY, PRIMARY } from '@/constants/color';
import { LOCATION_CHIPS_LIMIT } from '@/constants/geography';
import { Chip } from '@mui/material';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import NotFoundLocationChip from './NotFoundLocationsChip';
import RestLocationsChip from './RestLocationsChip';
import SelectedLocationChip from './SelectedLocationChip';

const CHIP_VARIANTS = {
  success: SelectedLocationChip,
  error: NotFoundLocationChip,
};

const LocationChips = ({
  locations = [],
  variant,
  onRemove,
  onRemoveAll,
  geoFenceLocation,
  radiusChip,
  onGeoFenceLocationRemove,
}) => {
  const shouldRadiusRender = Boolean(geoFenceLocation && radiusChip);
  const ChipComponent = useMemo(() => CHIP_VARIANTS[variant] ?? CHIP_VARIANTS.success, [variant]);

  return locations.length || shouldRadiusRender ? (
    <div className='flex gap-2 flex-wrap'>
      {shouldRadiusRender && (
        <SelectedLocationChip
          key='radius'
          locationName={geoFenceLocation}
          locationType={radiusChip}
          onRemove={onGeoFenceLocationRemove}
        />
      )}
      {locations.slice(0, LOCATION_CHIPS_LIMIT).map(({ id, displayName, type }) => (
        <ChipComponent
          variant={variant}
          key={id}
          locationName={displayName}
          locationType={type}
          onRemove={onRemove(id)}
        />
      ))}
      {locations.length > LOCATION_CHIPS_LIMIT && (
        <RestLocationsChip
          hiddenLocations={locations.slice(LOCATION_CHIPS_LIMIT)}
          numberOfHiddenLocations={locations.length - LOCATION_CHIPS_LIMIT}
          onRemove={onRemove}
        />
      )}
      {onRemoveAll && (
        <Chip
          className='print:hidden w-fit self-end'
          label='Clear selection'
          onClick={onRemoveAll}
          variant='outlined'
        />
      )}
    </div>
  ) : (
    <div className='flex items-center gap-2 px-3 py-1 border border-[#DADADA] w-[365px] rounded-full'>
      <span className={`text-[${PRIMARY}] text-[14px] font-semibold`}>United States</span>
      <span className={`text-[${GREY}] text-[12px]`}>This will forecast to nationwide, by default.</span>
    </div>
  );
};

LocationChips.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.object),
  onRemove: PropTypes.func,
  onRemoveAll: PropTypes.func,
  variant: PropTypes.oneOf(['success', 'error']),
  geoFenceLocation: PropTypes.string,
  radiusChip: PropTypes.string,
  onGeoFenceLocationRemove: PropTypes.func,
};

export default LocationChips;
